import { useMemo } from 'react';
import { Employee } from 'types/employees.ts';
import { formatEmployeeName, useLastNameFirst } from 'utils/nameOrder';
import { isEmail } from '../../forms/inputs/EmailListInput.tsx';

export const useActiveEmployees = (employees: Employee[]) => {
    const lastNameFirst = useLastNameFirst();
    return useMemo(() => {
        return employees
            .filter((emp) => emp.isActive && emp.workEmailAddress && isEmail(emp.workEmailAddress))
            .map((emp) => ({
                label: `${formatEmployeeName(emp, lastNameFirst)} (${emp.workEmailAddress})`,
                value: emp.id.toString(),
            }));
    }, [employees, lastNameFirst]);
};
